export default "__VITE_ASSET__Dx9qibz3__"